import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm, FormGroup, FormBuilder } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";

import { ObjectivesService } from "../../services/objectives.service";

@Component({
  selector: "app-objectives-modal",
  templateUrl: "./objectives-modal.component.html",
  providers: [ObjectivesService],
})
export class ObjectivesModalComponent implements OnInit {
  @Output() public objectiveReload: EventEmitter<any> = new EventEmitter<any>();
  formData: any = {
    code: "",
    description: "",
    comment: "",
    active: 0,
  };

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();
  // languageSystemID = +this.helperService.getAvailableLang();
  languageSystemID = 1;

  activeStatus = [
    { value: 0, label: "No" },
    // { value: 1, label: "Yes" },
  ];

  typeStatus = [
    // { value: '1', label: "Standard" },
    { value: "2", label: "Detail" },
  ];

  codeGenerated = "";

  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private objectivesService: ObjectivesService,
    private fb: FormBuilder
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.generateRandomDocNumber();
    console.log(this.codeGenerated);
  }

  generateRandomDocNumber() {
    const randomNumber = Math.floor(Math.random() * 99999) + 1;
    this.formData.code = `AM/${randomNumber.toString().padStart(6, "0")}`;
    this.codeGenerated = this.formData.code;
  }

  addObjective(formData: any) {
    const activeValue = formData.active === undefined ? 0 : formData.active;
    const requestData = {
      code: this.codeGenerated,
      description: formData.description,
      note: formData.note,
      type_id: formData.type,
      active: activeValue,
      company_id: this.companySystemID,
      language_id: this.languageSystemID,
    };

    let that = this;
    that.objectivesService
      .addObjective()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          that.successMsg = "";
          that.successMsg = "Successfully added a objective";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.objectiveReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
            this.objectiveReload.emit();
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-modal/objectives-modal.component.ts